import React from 'react';
import PriceModel from '../../Types/PriceModel';
import Icon from '../Icon';
import ProductPageProductPrice from './ProductPageProductPrice';
import { YotpoBottomLine } from '../../Types/Yotpo';
import RatingStars from '../RatingStars';
import Product from '../../Types/Product';
import FavoriteButton from '../FavoriteButton/FavoriteButton';
import { translate } from '../../Services/translation';
import clsx from 'clsx';
import {useTypedSelector} from "../../Hooks/useTypedSelector";

interface ProductPageProductInformationProps {
  title: string;
  priceModel?: PriceModel;
  bottomLine?: YotpoBottomLine;
  product: Product;
  muralCanvasDisclaimer?: string;
  isB2b?: boolean;
  articleNumber?: string;
}

const ProductPageProductInformation = ({
  title,
  priceModel,
  bottomLine,
  product,
  muralCanvasDisclaimer,
  isB2b = false,
  articleNumber,
}: ProductPageProductInformationProps) => {

  const { showProductReviews } = useTypedSelector(
      (state) => state.featureToggling
  );
  return (
    <>
      <div
        className={clsx(
          'mb-2 flex justify-between',
          !isB2b && 'items-center'
        )}
      >
        <div className="flex flex-col gap-1 w-full">
          {articleNumber && (
            <p className="text-lg font-normal leading-6 text-gray-700">
              {translate('general.article-number')}: {articleNumber}
            </p>
          )}
          <div className="flex justify-between">
            <h1 className="h3">{title}</h1>
            {showProductReviews && (
                <div className="mr-0">
                  <RatingStars rating={bottomLine?.average_score} />
                </div>
            )}
          </div>
        </div>
        <FavoriteButton
          className="flex"
          iconClassName="w-6 h-6"
          iconWrapperClassName="flex items-center justify-center"
          product={product}
        />
      </div>
      <a className="mb-4 flex justify-between">
        {priceModel && (
          <ProductPageProductPrice
            priceModel={priceModel}
            itemPackageSize={product.itemPackageSize ?? 0}
          />
        )}
        {bottomLine && <RatingStars rating={bottomLine.average_score} />}
      </a>
      {isB2b && (
        <div className="mb-4 flex flex-col">
          {product.itemCollection && (
            <p className="text-lg font-normal text-gray-700">
              {translate('general.collection')}: {product.itemCollection}
            </p>
          )}
          {product.itemPackageSize && product.itemPackageSize > 0 && (
            <p className="text-lg font-normal text-gray-700">{`${
              product.itemPackageSize
            } ${product.price.price?.unitOfMeasurementTitle} / ${translate(
              'detailed-product-card.boxes'
            )} `}</p>
          )}
        </div>
      )}
      {muralCanvasDisclaimer && (
        <p className="mb-4 text-lg font-light leading-6 text-gray-900">
          {muralCanvasDisclaimer}
        </p>
      )}
    </>
  );
};

export default ProductPageProductInformation;
